export default {
	updateSupplierAcceptTaxAuthority(state, res) {
		state.SupplierAcceptTaxAuthority = res;
	},
	updateSupplierAcceptTaxAuthorities(state, res) {
		state.SupplierAcceptTaxAuthorities = res;
	},
	updateTotalSupplierAccept: function(state, res) {
		state.Total = res;
	},
	updateTotalPage(state, res) {
		state.Total = res;
	},
	updateIsLoadingData(state, res) {
		state.IsLoadingData = res;
	}
};
